import { render } from "./BalanceTransactions.vue?vue&type=template&id=4bc6435d"
import script from "./BalanceTransactions.vue?vue&type=script&lang=js"
export * from "./BalanceTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__